import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { UsersTable } from '@app/components/apps/Users/UserTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import FilterComponent from '@app/components/TableFilter/TableFilter';

const AllUsers: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/add-users');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb routes={[{ path: '/users', breadcrumbName: 'Users' }]} style={{ marginBottom: '15px' }} />,
    );

    addHeaderButton(
      'Add User',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Users</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <UsersTable />
        </Col>
      </Row>
    </>
  );
};

export default AllUsers;
